import React, { useState, useEffect } from 'react';
import Layout from 'layout';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid
} from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { authenticationService } from 'auth/authenticationService';

export default function EstadoServicios() {
  const [loading, setLoading] = useState(false);
  const [soaploading, setSoapLoading] = useState(false);


  const [status, setStatus] = useState(null);
  const [soapStatus, setSoapStatus] = useState(null);

  const [prtMsg, setPrtMsg] = useState('')
  const [soapMsg, setSoapMsg] = useState('')

  const getStatusResponse = (res) => {
    // Si la respuesta existe y el status interno es 1, está activo.
    // De lo contrario (es 0, o viene en un formato inesperado), está inactivo.
    if (res && res.status === 1) {
      return 'active';
    }
    return 'inactive';
  };


  const checkStatusPRT = () => {
    setLoading(true);
    setStatus(null);
    setPrtMsg(''); // Limpiamos el mensaje anterior
    
    authenticationService.fetchApi({
      url: '/permisos/prt_status/XXXX11',
      method: 'GET',
      no_error_popup: true
    })
    .then((res) => {
      setLoading(false);
      setStatus(getStatusResponse(res));
      if (res && res.msg) {
        setPrtMsg(res.msg); // Capturamos mensaje de éxito
      }
    })
    .catch((err) => {
      setLoading(false);
      setStatus('inactive'); // Corrección del bug de setStatus
      
      // Capturamos el mensaje de error que manda el backend (HTTP 500)
      // Ajusta 'err.response?.data?.msg' o 'err.msg' según cómo trabaje tu fetchApi
      const errorMsg = err.response?.data?.msg || err.msg || 'Error de conexión';
      setPrtMsg(errorMsg); 
    });
  };

  const checkStatusSOAP = () => {
    setSoapLoading(true);
    setSoapStatus(null);
    setSoapMsg(''); // Limpiamos el mensaje anterior
    
    authenticationService.fetchApi({
      url: '/permisos/soap_status/XXXX11',
      method: 'GET',
      no_error_popup: true
    })
    .then((res) => {
      setSoapLoading(false);
      setSoapStatus(getStatusResponse(res));
      if (res && res.msg) {
        setSoapMsg(res.msg); // Capturamos mensaje de éxito
      }
    })
    .catch((err) => {
      setSoapLoading(false);
      setSoapStatus('inactive');
      
      // Capturamos el mensaje de error del backend
      const errorMsg = err.response?.data?.msg || err.msg || 'Error de conexión';
      setSoapMsg(errorMsg);
    });
  };

  useEffect(() => {
    checkStatusPRT();
    checkStatusSOAP();
  }, []);

  return (
    <Layout>
      <Box mt={3}>
        <Typography variant="h5" gutterBottom>
          Estado de Servicios
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="h6">PRT API (get_prt)</Typography>
                  <Button 
                    variant="outlined" 
                    color="primary" 
                    startIcon={<ReplayIcon />}
                    onClick={checkStatusPRT}
                    disabled={loading}
                  >
                    Reintentar
                  </Button>
                </Box>
                <Box mt={2} display="flex" alignItems="center">
                  <Typography variant="body1" sx={{ mr: 1 }}>
                    Estado:
                  </Typography>
                  {loading ? (
                    <CircularProgress size={24} />
                  ) : status === 'active' ? (
                    <Box display="flex" alignItems="center" color="success.main">
                      <CheckCircleIcon sx={{ mr: 0.5 }} />
                      <Typography variant="body1" fontWeight="bold">
                        Activo
                      </Typography>
                    </Box>
                  ) : status === 'inactive' ? (
                    <Box display="flex" alignItems="center" color="error.main">
                      <CancelIcon sx={{ mr: 0.5 }} />
                      <Typography variant="body1" fontWeight="bold">
                        Inactivo
                      </Typography>
                    </Box>
                  ) : null}
                </Box>
                <Box>
                  <Typography variant="body1">{prtMsg}</Typography>
                </Box>
              </CardContent>
            </Card>
            <Card sx={{mt: 2}}>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="h6">SOAP API (get_soap)</Typography>
                  <Button 
                    variant="outlined" 
                    color="primary" 
                    startIcon={<ReplayIcon />}
                    onClick={checkStatusSOAP}
                    disabled={soaploading}
                  >
                    Reintentar
                  </Button>
                </Box>
                <Box mt={2} display="flex" alignItems="center">
                  <Typography variant="body1" sx={{ mr: 1 }}>
                    Estado:
                  </Typography>
                  {soaploading ? (
                    <CircularProgress size={24} />
                  ) : soapStatus === 'active' ? (
                    <Box display="flex" alignItems="center" color="success.main">
                      <CheckCircleIcon sx={{ mr: 0.5 }} />
                      <Typography variant="body1" fontWeight="bold">
                        Activo
                      </Typography>
                    </Box>
                  ) : soapStatus === 'inactive' ? (
                    <Box display="flex" alignItems="center" color="error.main">
                      <CancelIcon sx={{ mr: 0.5 }} />
                      <Typography variant="body1" fontWeight="bold">
                        Inactivo
                      </Typography>
                    </Box>
                  ) : null}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}
